import url from 'url';

const INTERNAL_HOST = 'modaoperandi.com';

export const stripInternalHost = (href: string) => {
  const { hostname, path, hash } = url.parse(href);

  if (hostname?.endsWith(INTERNAL_HOST)) {
    return [path, hash].filter(Boolean).join('');
  }

  // Likely an external URL
  return href;
};
